import { PubSub } from '../../../../utils/eventUtils';

/**
 * Example of use
 *
 * Modal.deferShow(TestModalConfig, {
 *   data: { custom: 'data' },
 * });
 *
 */
export const Modal = {
  /**
   * @name show
   * @description immediately show a modal
   * @param nextModal: config object of the modal to be injected
   * @param modalMeta: inline configuration overrides
   */
  show(nextModal, modalMeta = {}) {
    const { component, config: defaultConfig = {} } =
      deriveModalConfig(nextModal);

    const { config: inlineConfig = {}, ...metaRest } = modalMeta;

    PubSub.publish('modal:show', {
      config: { ...defaultConfig, ...inlineConfig },
      ...metaRest,
      component,
    });
  },

  /**
   * @name hide
   * @description hide the modal
   */
  hide() {
    PubSub.publish('modal:hide');
  },

  deferShow(nextModal, modalMeta) {
    return () => {
      this.show(nextModal, modalMeta);
    };
  },

  deferHide() {
    return () => {
      this.hide();
    };
  },
};

const deriveModalConfig = (nextModal) => {
  // remove intermediate layer from modal config object
  const [nextModalConfig] = Object.keys(nextModal).map((key) => nextModal[key]);
  return nextModalConfig;
};
